<body class="bg-gray-100">
  <app-header></app-header>

  <!-- Banner Image Section - Adjusted heights for mobile -->
  <div
    class="w-full h-48 sm:h-64 md:h-80 lg:h-96 bg-contain bg-center"
    style="
      background-image: url('assets/TrailFusion/Miscellaneous/toronto.webp');
    "
  >
    <div class="flex items-center justify-center h-full">
      <h1
        class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-teal-600 bg-opacity-50 text-white text-center px-4"
      >
        {{ programDetail[currentIndex]?.name }}
      </h1>
    </div>
  </div>

  <!-- Animated Images - Hidden on small screens -->
  <!-- Left Side Images -->
  <div class="hidden sm:block image-container left-image-1">
    <img
      src="assets\TrailFusion\Miscellaneous\11.webp"
      alt="Left Image 1"
      class="blob floating"
    />
  </div>
  <div class="hidden sm:block image-container left-image-2">
    <img
      src="assets\TrailFusion\Miscellaneous\10.webp"
      alt="Left Image 2"
      class="blob floating"
    />
  </div>

  <!-- Right Side Images -->
  <div class="hidden sm:block image-container right-image-1">
    <img
      src="assets\TrailFusion\Miscellaneous\9.webp"
      alt="Right Image 1"
      class="blob floating"
    />
  </div>
  <div class="hidden sm:block image-container right-image-2">
    <img
      src="assets\TrailFusion\Miscellaneous\8.webp"
      alt="Right Image 2"
      class="blob floating"
    />
  </div>

  <!-- Main Content -->
  <div
    class="container mx-auto px-4 sm:px-6 py-6 sm:py-8 max-w-4xl mt-4 sm:mt-8 relative"
  >
    <!-- Introduction -->
    <div class="text-center animate-fade-in">
      <h2 class="text-xl sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4">
        Introduction
      </h2>
      <p class="text-base sm:text-lg mb-4 sm:mb-6 animate-fade-in">
        At TrailFusion, we believe in nurturing young minds through engaging and
        enriching programs tailored for children. Our carefully designed
        activities focus on learning, creativity, and personal growth, ensuring
        that every child gains valuable skills while having fun. Whether it's
        sports, arts, science, or adventure-based experiences, we provide a safe
        and stimulating environment where children can explore their interests,
        build confidence, and create lasting memories.
      </p>
    </div>

    <div class="relative w-full flex justify-center">
      <div
        class="relative bg-white p-4 sm:p-6 md:p-6 rounded-lg shadow-2xl mb-6 sm:mb-8 animate-slide-in-left w-full sm:w-[90%] md:w-[90%]"
      >
        <div *ngIf="programDetail.length > 0; else noProgramDetail">
          <div
            class="flex flex-row items-center justify-between gap-4 relative flex-wrap"
          >
            <!-- Program Name -->
            <h2
              class="text-base sm:text-2xl md:text-2xl font-bold text-teal-800 flex-1"
            >
              {{ programDetail[currentIndex]?.name }}
            </h2>

            <!-- Program Image -->
            <img
              *ngIf="getCleanImage(programDetail[currentIndex]?.communityImage)"
              [src]="getCleanImage(programDetail[currentIndex]?.communityImage)"
              alt="Community Image"
              class="w-20 h-20 sm:w-24 sm:h-24 object-contain"
            />
          </div>

          <br />
          <p
            class="text-base sm:text-lg mb-4 sm:mb-6"
            [innerHTML]="
              programDetail[currentIndex]?.description ||
              'No description available'
            "
          ></p>

          <div class="overflow-x-auto">
            <div class="space-y-4">
              <!-- Age Group -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i class="fas fa-users text-teal-600 mr-2 w-5 text-base"></i>
                  Age Group:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.ageGroup || "N/A" }}
                </div>
              </div>

              <!-- Community -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i class="fas fa-globe text-teal-600 mr-2 w-5 text-base"></i>
                  Community:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.community || "N/A" }}
                </div>
              </div>

              <!-- Instructor -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-start font-semibold mr-2">
                  <i
                    class="fas fa-chalkboard-teacher text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Instructor:
                </div>
                <div class="text-gray-700">
                  {{
                    programDetail[currentIndex]?.teacher ||
                      "No instructor available"
                  }}
                </div>
              </div>

              <!-- Location -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-start font-semibold mr-2">
                  <i
                    class="fas fa-map-marker-alt text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Location:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.location || "N/A" }}
                </div>
              </div>

              <!-- Start Date -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i
                    class="fas fa-calendar-alt text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Start Date:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.startDate || "N/A" }}
                </div>
              </div>

              <!-- End Date -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i
                    class="fas fa-calendar-alt text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  End Date:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.endDate || "N/A" }}
                </div>
              </div>

              <!-- Available Spaces -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i class="fas fa-users text-teal-600 mr-2 w-5 text-base"></i>
                  Available Spaces:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.availableSpace || "N/A" }}
                </div>
              </div>

              <!-- Fee -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-center font-semibold mr-2">
                  <i
                    class="fas fa-dollar-sign text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Fee:
                </div>
                <div class="text-gray-700">
                  {{ programDetail[currentIndex]?.fee | currency : "CAD" }}
                </div>
              </div>

              <!-- Payment Term -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-start font-semibold mr-2">
                  <i
                    class="fas fa-file-invoice-dollar text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Payment Term:
                </div>
                <div
                  class="text-gray-700"
                  [innerHTML]="
                    programDetail[currentIndex]?.term ||
                    'Payment terms not available'
                  "
                ></div>
              </div>

              <!-- Disclaimer -->
              <div class="flex flex-wrap text-gray-800">
                <div class="flex items-start font-semibold mr-2">
                  <i
                    class="fas fa-exclamation-circle text-teal-600 mr-2 w-5 text-base"
                  ></i>
                  Disclaimer:
                </div>
                <div
                  class="text-gray-700"
                  [innerHTML]="
                    programDetail[currentIndex]?.disclaimer ||
                    'No disclaimer at this time'
                  "
                ></div>
              </div>
            </div>
          </div>

          <h4 class="text-xl sm:text-2xl font-bold mt-6 sm:mt-8 text-teal-800">
            What will participant gain?
          </h4>
          <p class="mt-2 sm:mt-4 text-gray-700 text-sm sm:text-base">
            {{
              programDetail[currentIndex]?.comments || "No comments available."
            }}
          </p>
          <div
            class="mt-6 sm:mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4"
          >
            <button class="w-full sm:w-auto">
              <a
                (click)="navigateToSignUp()"
                class="w-full px-4 py-2 sm:px-6 sm:py-3 md:px-8 md:py-3 bg-teal-900 hover:bg-teal-600 hover:scale-105 transition-all duration-300 text-white font-semibold rounded-full shadow-lg flex items-center justify-center gap-2 text-sm sm:text-base"
              >
                <i class="fas fa-user-plus"></i> Register Now
              </a>
            </button>
            <button class="w-full sm:w-auto">
              <a
                (click)="navigateToSignIn()"
                class="w-full px-4 py-2 sm:px-6 sm:py-3 md:px-8 md:py-3 bg-teal-900 hover:bg-teal-600 hover:scale-105 transition-all duration-300 text-white font-semibold rounded-full shadow-lg flex items-center justify-center gap-2 text-sm sm:text-base"
              >
                <i class="fas fa-sign-in-alt"></i> Sign In
              </a>
            </button>
          </div>
          <br />
          <p
            class="mt-2 sm:mt-4 text-gray-700 text-sm sm:text-base text-center"
          >
            {{ programDetail[currentIndex]?.orgName }} |
            {{ programDetail[currentIndex]?.orgAddress }} |
            {{ programDetail[currentIndex]?.orgPhone }}
          </p>
        </div>

        <ng-template #noProgramDetail>
          <div class="text-center py-12">
            <p class="text-xl text-gray-500">
              There are no program details to display at this time
            </p>
          </div>
        </ng-template>
      </div>
    </div>
    <div>
      <button
        (click)="prevProgram()"
        class="absolute left-0 sm:-left-8 top-1/2 bg-teal-900 text-white p-2 sm:p-3 md:p-4 rounded-full hover:bg-teal-600 shadow-lg"
      >
        <i class="fas fa-chevron-left text-sm sm:text-base"></i>
      </button>
      <button
        (click)="nextProgram()"
        class="absolute right-0 sm:-right-8 top-1/2 bg-teal-900 text-white p-2 sm:p-3 md:p-4 rounded-full hover:bg-teal-600 shadow-lg"
      >
        <i class="fas fa-chevron-right text-sm sm:text-base"></i>
      </button>
    </div>

    <!-- Conclusion Section -->
    <div class="text-center animate-fade-in">
      <h2 class="text-xl sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4">
        Conclusion
      </h2>
      <p class="text-base sm:text-lg">
        All in all, our programs at TrailFusion are designed to inspire,
        educate, and empower children to reach their full potential. By
        fostering curiosity, teamwork, and resilience, we help them develop
        essential life skills that go beyond the classroom. Join us on this
        exciting journey and give your child the opportunity to grow, learn, and
        thrive in a supportive and dynamic environment!
      </p>
    </div>
  </div>
  <app-footer></app-footer>
</body>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
/>
